import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquareText, Menu, X } from 'lucide-react';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  
  return (
    <nav className="bg-white shadow-md py-4">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-2">
            <MessageSquareText className="w-8 h-8 text-emerald-600" />
            <span className="text-xl font-bold text-gray-800">Account Services</span>
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-emerald-600 font-medium">
              Home
            </Link>
            <Link to="/pricing" className="text-gray-700 hover:text-emerald-600 font-medium">
              Pricing
            </Link>
            <Link to="/docs" className="text-gray-700 hover:text-emerald-600 font-medium">
              Documentation
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-emerald-600 font-medium">
              Contact
            </Link>
          </div>
          
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/signin" className="text-emerald-600 hover:text-emerald-800 font-medium">
              Sign In
            </Link>
            <Link 
              to="/signup" 
              className="bg-emerald-600 text-white px-5 py-2 rounded-md hover:bg-emerald-700 transition duration-300"
            >
              Get Started
            </Link>
          </div>
          
          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-emerald-600 focus:outline-none"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pt-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link to="/" 
                className="text-gray-700 hover:text-emerald-600 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link to="/pricing" 
                className="text-gray-700 hover:text-emerald-600 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Pricing
              </Link>
              <Link to="/docs" 
                className="text-gray-700 hover:text-emerald-600 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Documentation
              </Link>
              <Link to="/contact" 
                className="text-gray-700 hover:text-emerald-600 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
              <div className="flex flex-col space-y-3 pt-3 border-t border-gray-200">
                <Link to="/signin" 
                  className="text-emerald-600 hover:text-emerald-800 font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Sign In
                </Link>
                <Link 
                  to="/signup" 
                  className="bg-emerald-600 text-white px-5 py-2 rounded-md hover:bg-emerald-700 transition duration-300 text-center"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;